export default __webpack_public_path__ + "static/media/sortIcon.36aac4cc.svg";